import React from "react";
import { Tabs } from "@/components/ui/Tabs";
import { useAuthStore } from "@/store/authStore";

export const AccountsTabs = ({ activeTab, onTabChange }) => {
  const { user } = useAuthStore();

  let tabs = [
    { id: "accounts_master", label: "Accounts Master" },
    { id: "project_expenses", label: "Project Expenses" },
    /* Developer : Nithin
    Date : 26-06-2026
    changes: commented out General Expenses tab from Accounts view */
    // { id: "general_expenses", label: "General Expenses" },
    { id: "material_expenses", label: "Material Expenses" },
    { id: "received_amount", label: "Received Amount" },
  ];

  if (user && (user.role === 'project-manager' || user.role === 'store-manager')) {
    tabs = tabs.filter(tab => tab.id === 'project_expenses' || tab.id === 'general_expenses');
  }

  return (
    <div className="bg-white rounded-xl shadow-sm px-6 pt-4">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={onTabChange}
        variant="sub"
      />
    </div>
  );
};
